import React from 'react';

export enum Checked {
  FALSE = 0,
  TRUE = 1,
  INDETERMINATE = 2
}

interface CheckboxProps {
  value: Checked;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
}

export default class Checkbox extends React.Component<
  React.PropsWithChildren<CheckboxProps>
> {
  public checkboxRef!: React.RefObject<HTMLInputElement>;

  public componentDidUpdate(): void {
    if (this.checkboxRef?.current) {
      this.checkboxRef.current.indeterminate =
        this.props.value === Checked.INDETERMINATE;
    }
  }

  public componentDidMount(): void {
    this.checkboxRef = React.createRef<HTMLInputElement>();
  }

  public render(): JSX.Element {
    const checked = this.props.value === Checked.TRUE;

    return (
      <div className="form-check">
        <label>
          <input
            type="checkbox"
            className="form-check-input"
            checked={checked}
            ref={this.checkboxRef}
            onChange={this.props.onChange}
          />
          {this.props.children}
        </label>
      </div>
    );
  }
}
